// Shared restaurant image URL builder.
// Centralizes the upload → eventSpace → Google Places fallback chain.

import { mediaUrl } from './mediaUrl'

export function buildGooglePhotoUrl(photoReference, opts = {}) {
  if (!photoReference) return null
  const maxWidth = opts.maxWidth || 200
  const maxHeight = opts.maxHeight || 200
  const apiKey = import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY

  return `https://d128sk95sboo22.cloudfront.net/maps/api/place/photo?maxwidth=${maxWidth}&maxheight=${maxHeight}&photo_reference=${photoReference}&key=${apiKey}`
}

export function getRestaurantImageUrl(restaurant, opts = {}) {
  const fallback = Object.prototype.hasOwnProperty.call(opts, 'fallback') ? opts.fallback : null
  if (!restaurant) return fallback

  const version = opts.mediaPath || 'thumb'
  const includeEventSpaces = opts.includeEventSpaces !== false

  if (restaurant.imageIds && restaurant.imageIds.length > 0) {
    return mediaUrl(restaurant.imageIds[0], version)
  }

  if (includeEventSpaces && restaurant.eventSpaces && restaurant.eventSpaces.length > 0) {
    const space = restaurant.eventSpaces.find(s => s && s.imageId)
    if (space) return mediaUrl(space.imageId, version)
  }

  const photoRef = restaurant.googlePlaceDetails
    && restaurant.googlePlaceDetails.photos
    && restaurant.googlePlaceDetails.photos[0]
    && restaurant.googlePlaceDetails.photos[0].photo_reference

  if (photoRef) return buildGooglePhotoUrl(photoRef, opts)

  return fallback
}
